<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md6 sm12 lg6 first-row>
        <material-card :key="dataLoaded">
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Client Detail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1' && !clientDetails.canBeEdited"
              @click.stop="enableEditing()"
            >Edit Client</v-btn>
            <v-btn
              class="ma-2"
              color="pink"
              v-if="clientDetails.canBeEdited"
              @click.stop="updateClient()"
            >Save Changes</v-btn>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="clientDetails.canBeEdited"
              @click.stop="cancelEditing()"
            >Cancel</v-btn>
          </v-toolbar>
          <v-form ref="clientDetail">
          <v-form-base
            v-bind:value="clientDetails.data"
            v-bind:schema="clientSchema.client"
            :key="dataLoaded"
          />
          </v-form>
        </material-card>
      </v-flex>

      <!-- Contacts -->
      <v-flex md6 sm12 lg6 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Contacts</v-toolbar-title>
             <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1' && clientContacts.length < 2"
              @click.stop="contactDialog = true"
            >Add contact</v-btn>
          </v-toolbar>
          <contact-card
            v-for="contact in clientContacts"
            :key="contact.contact_type_id"
            :contact="contact"
            :editVisible="loggedUser.role === '1'"
            @contact-updated="updateContact"
          />
          <div v-if="clientContacts.length === 0 " class="py-8 text-center">There are no contacts</div>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Campaigns</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="addCampaign()"
              v-if="loggedUser.role === '1'"
            >Add Campaign</v-btn>
          </v-toolbar>
          <v-data-table
            :headers="campaignsTable.headers"
            :items="campaignsTable.data"
            :options.sync="campaignsTable.options"
            :server-items-length="campaignsTable.total"
            :loading="campaignsTable.loading"
            class="elevation-1"
            :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
            :items-per-page="15"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
            </template>
            <template v-slot:item.name="{ item }">
              <router-link
                :to="{ name: 'campaigndetail', params: { campaignId: item.id } }"
              >{{ item.name }}</router-link>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small @click="disassociateCampaign(item.id)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Merchants</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="dialogMerchant = true"
              v-if="loggedUser.role === '1'"
            >Add Merchant</v-btn>
          </v-toolbar>
          <v-data-table
            :headers="merchantsTable.headers"
            :items="merchantsTable.data"
            :options.sync="merchantsTable.options"
            :loading="merchantsTable.loading"
            class="elevation-1"
            :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
            :items-per-page="15"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
            </template>
            <template v-slot:item.name="{ item }">
              <router-link
                :to="{ name: 'merchantdetail', params: { merchantId: item.id } }"
              >{{ item.name }}</router-link>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Leads</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="leadsTable.filter"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>

          <v-data-table
            :headers="leadsTable.headers"
            :items="leadsTable.data"
            :options.sync="leadsTable.options"
            :search="leadsTable.filter"
            :loading="leadsTable.loading"
            class="elevation-1"
            :footer-props="{
                'items-per-page-options': [10, 15, 20, 30, 50]
              }"
            :items-per-page="15"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
            </template>
            <template v-slot:item.date_created="{ item }">{{ item.date_created| formatDate }}</template>
            <template v-slot:item.email_confirmed="{ item }">
          <td><v-icon
          :color="item.email_confirmed ? 'green' : ''"
        >
          mdi-checkbox-marked-circle
        </v-icon></td>
        </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-dialog v-model="dialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Associate Campaign</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-radio-group v-model="dialogm1" column>
              <v-radio
                v-for="campaign in availableCampaignsList"
                :key="campaign.id"
                :label="campaign.name"
                :value="campaign.id"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="secondary darken-1" outlined @click="dialog = false">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="associateCampaign(dialogm1); dialog = false"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="contactDialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Add Contact</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-form ref="newContact" v-model="newContactFormValid">
            <v-form-base
                v-bind:value="newContactData"
                v-bind:schema="contactSchema"
              />
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="secondary darken-1" outlined @click="contactDialog = false">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="addContact(newContactData); contactDialog = false"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogMerchant" scrollable max-width="500px">
        <v-card>
          <v-card-title>Create Merchant</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-form ref="newMerchant" v-model="newMererchantFormValid">
              <v-form-base
                v-bind:value="newMerchantDetails.data.merchant"
                v-bind:schema="newMerchantSchema.merchant"
              />
              <h2>Legal Representative</h2>
              <v-form-base
                v-bind:value="newMerchantDetails.data.contacts.referente"
                v-bind:schema="newMerchantSchema.contacts.referente"
              />
              <h2>Tecnical Contact</h2>
              <v-form-base
                v-bind:value="newMerchantDetails.data.contacts.rappresentante"
                v-bind:schema="newMerchantSchema.contacts.rappresentante"
              />
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="secondary darken-1" outlined @click="dialogMerchant = false">Close</v-btn>
            <v-btn
              color="primary darken-1"
              @click="createMerchant(); dialogMerchant = false"
            >Add merchant</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>

import apiService from '../services'
import VFormBase from 'vuetify-form-base'
import ContactCard from '@/components/common-components/ComponentContactCard'
import { mapState } from 'vuex'
import formRules from '@/mixins'
import ibanApiService from '../utilityes'

export default {
  watch: {
    options: {
      handler () {
        this.getClient(this.$route.params.clientId)
      },
      deep: true
    }
  },
  components: {
    VFormBase,
    ContactCard
  },
  data () {
    return {
      newContactData: {},
      newContactFormValid: true,
      dialog: false,
      contactDialog: false,
      dialogMerchant: false,
      newMererchantFormValid: true,
      dialogm1: '',
      formValid: true,
      editContact: false,
      dataLoaded: false, // Used to trigger form components re-rendering

      clientDetails: {
        canBeEdited: false,
        data: {}
      },

      merchantDetails: {
        canBeEdited: false,
        data: {}
      },
      newMerchantDetails: {
        canBeEdited: false,
        data: {
          merchant: {},
          contacts: {
            rappresentante: {},
            referente: {}
          },
          user: {}
        }
      },

      clientContacts: [],
      campaignsList: [],
      availableCampaignsList: [],

      // Tabella merchants
      merchantsTable: {
        headers: [
          { text: 'Merchant', value: 'name' },
          { text: 'Relazione', value: 'relation_name' }
        ],
        data: [],
        total: 0,
        loading: true,
        options: {}
      },

      // Campaigns table
      campaignsTable: {
        headers: [
          { text: 'Campaign', value: 'name' },
          { text: 'Description', value: 'description' },
          { text: 'Status', value: 'status_name' },
          { text: 'Actions', value: 'action', sortable: false }
        ],
        data: [],
        total: 0,
        loading: false,
        options: {}
      },

      leadsTable: {
        headers: [
          { text: 'First name', value: 'first_name', sortable: true },
          { text: 'Last name', value: 'last_name', sortable: true },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'Date created', value: 'date_creation', sortable: true },
          { text: 'Merchant', value: 'merchant_name', sortable: true },
          { text: 'Campaign', value: 'campaign_name', sortable: true },
          { text: 'Confirmed', value: 'email_confirmed', sortable: true }
        ],
        data: [],
        total: 0,
        loading: false,
        options: {},
        filter: ''
      },
      loading: true,
      primaryMerchant: {},
      legalRepresentative: [],
      primaryContact: [],
      contactsTableContent: []
    }
  },
  computed: {
    fullName () {
      return (
        this.legalRepresentative.first_name +
          ' ' +
          this.legalRepresentative.last_name || null
      )
    },
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas', 'relations']),

    // Add Notification service and auth service for UI Role control
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },

    loggedUser () {
      return this.auth.user || null
    },

    canEdit () {
      return this.loggedUser.role === '1'
    },

    clientSchema () {
      return {
        client: {
          name: {
            type: 'text',
            label: 'Name *',
            flex: 12,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [this.validationRules.requiredField('Name')]
          },
          description: {
            type: 'textarea',
            label: 'Description',
            counter: 1500,
            maxlength: 1500,
            readonly: this.clientDetails.canBeEdited === false,
            flex: 12
          },
          vat_number: {
            type: 'text',
            label: 'Vat Number *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            max: 11,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [
              this.validationRules.requiredField('Vat Number'),
              v => (v && v.length === 11) || `Vat Number must be 11 characters long`
            ]
          },
          iban: {
            type: 'text',
            label: 'IBAN *',
            flex: 12,
            counter: 27,
            maxlength: 27,
            loading: this.clientDetails.ibanLoading === true,
            max: 27,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [
              this.validateIban,
              v => (v && v.length === 27) || `IBAN must be 27 characters long`
            ]
          },
          fiscal_code: {
            type: 'text',
            label: 'Fiscal code *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            max: 11,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [
              v => (v && v.length === 11) || `Fiscal code must be 11 characters long`
            ]
          },
          address: {
            type: 'text',
            label: 'Address *',
            readonly: this.clientDetails.canBeEdited === false,
            flex: 12,
            rules: [this.validationRules.requiredField('Address')]
          },
          zip_code: {
            type: 'text',
            label: 'Zip Code *',
            flex: 6,
            mask: '#####',
            maxlength: 5,
            counter: 5,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [
              this.validationRules.requiredField('Zip Code'),
              v => (v && v.length === 5) || `Zip Code must be 5 characters long`
            ]
          },
          city: {
            type: 'text',
            label: 'City *',
            readonly: this.clientDetails.canBeEdited === false,
            flex: 6,
            rules: [this.validationRules.requiredField('City')]
          },
          province: {
            type: 'text',
            label: 'Province *',
            flex: 6,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [this.validationRules.requiredField('Province')]
          },
          state: {
            type: 'text',
            label: 'State *',
            flex: 6,
            readonly: this.clientDetails.canBeEdited === false,
            rules: [this.validationRules.requiredField('Province')]
          },
          ateco_code: {
            type: 'text',
            label: 'Ateco Code',
            readonly: this.clientDetails.canBeEdited === false,
            flex: 12
          },
          website: {
            type: 'text',
            label: 'Website',
            readonly: this.clientDetails.canBeEdited === false,
            flex: 12
          },
          status: {
            type: 'select',
            label: 'Status',
            items: this.statuses.clients,
            itemValue: 'id',
            itemText: 'status_name',
            readonly: this.clientDetails.canBeEdited === false,
            rules: [v => !!v || 'Status is required'],
            flex: { xs: 12, sm: 6 }
          }
        }
      }
    },
    contactSchema () {
      return {
        first_name: {
          type: 'text',
          label: 'First name *',
          flex: 6,
          rules: [this.validationRules.requiredField('First name')]
        },
        last_name: {
          type: 'text',
          label: 'Last name *',
          flex: 6,
          rules: [this.validationRules.requiredField('Last name')]
        },
        email: {
          type: 'text',
          label: 'Email *',
          flex: 6,
          rules: [
            this.validationRules.requiredField('Email')
          ]
        },
        phone: {
          type: 'text',
          label: 'Phone *',
          flex: 6
        },
        is_legal_rep: {
          type: 'checkbox',
          label: 'Is legal representative',
          flex: 12
        },
        is_tech_rep: {
          type: 'checkbox',
          label: 'Is tecnical contact',
          flex: 12
        }
      }
    },

    newMerchantSchema () {
      let clientRelationshipList = this.relations
      return {
        merchant: {
          name: {
            type: 'text',
            label: 'Name *',
            flex: 12,
            rules: [this.validationRules.requiredField('Name')]
          },
          description: {
            type: 'textarea',
            label: 'Description',
            flex: 12
          },
          relation: {
            type: 'select',
            label: 'Client Relationship *',
            clearable: false,
            items: clientRelationshipList,
            returnObject: false,
            itemValue: 'id',
            itemText: 'name',
            rules: [v => !!v || 'Client Relationship is requiredField'],
            flex: { xs: 12, sm: 6 }
          },
          vat_number: {
            type: 'text',
            label: 'Vat Number *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            rules: [
              this.validationRules.requiredField('Vat Number'),
              this.validationRules.requiredlength('Vat Number', 11)
            ]
          },
          address: {
            type: 'text',
            label: 'Address *',
            flex: 12,
            rules: [this.validationRules.requiredField('Address')]
          },
          zip_code: {
            type: 'text',
            label: 'Zip Code *',
            mask: '############',
            maxlength: 5,
            flex: 6,
            rules: [
              this.validationRules.requiredField('Zip Code'),
              this.validationRules.requiredlength('Zip Code', 5)
            ]
          },
          city: {
            type: 'text',
            label: 'City *',
            flex: 4,
            rules: [this.validationRules.requiredField('City')]
          },
          province: {
            type: 'text',
            label: 'Province *',
            flex: 2,
            rules: [this.validationRules.requiredField('Province')]
          },
          fiscal_code: {
            type: 'text',
            label: 'Fiscal code *',
            flex: 12,
            counter: 11,
            mask: '############',
            maxlength: 11,
            max: 11,
            rules: [
              this.validationRules.requiredField('Fiscal code'),
              this.validationRules.requiredlength('Fiscal code', 11)
            ]
          },
          ateco_code: {
            type: 'text',
            label: 'Ateco Code',
            flex: 12
          },
          iban: {
            type: 'text',
            label: 'IBAN *',
            flex: 12,
            counter: 27,
            maxlength: 27,
            max: 27,
            rules: [
              this.validationRules.requiredField('IBAN'),
              this.validationRules.requiredlength('IBAN', 27)
            ]
          },

          website: {
            type: 'text',
            label: 'Website',
            flex: 12
          }
        },
        contacts: {
          referente: {
            first_name: {
              type: 'text',
              label: 'First name',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone',
              flex: 6,
              rules: [this.validationRules.requiredField('Phone')]
            }
          },
          rappresentante: {
            first_name: {
              type: 'text',
              label: 'First name',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone',
              flex: 6,
              rules: [this.validationRules.requiredField('Phone')]
            }
          }
        }
      }
    }
  },
  mounted () {
    this.getClient(this.$route.params.clientId)
    this.getCampaigns()
    if (this.loggedUser.role === '1') {
      this.getAvailableCampaigns(this.$route.params.clientId)
    }
    this.getLeads(this.$route.params.clientId)
  },
  mixins: [formRules],

  methods: {
    getClient (clientId) {
      this.loading = true

      // GET client by client id
      apiService
        .getClient(clientId)
        .then((response) => {
          setTimeout(() => {
            this.clientDetails.data = response.data

            // GET Client contacts
            apiService
              .getEntityContacts('client', clientId)
              .then(response => {
                this.clientContacts = response || []
              })

            // GET Merchants
            apiService
              .getMerchantsByClient(clientId)
              .then(response => {
                this.merchantsTable.data = response || []
              })

            this.dataLoaded = !this.dataLoaded
            this.merchantsTable.loading = false
          }, 800)
        })
        .catch((error) => {
          this.loading = false
          this.merchantsTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error loading client data'
          })
          console.log('Error', error)
        })
    },
    enableContactEditing () {
      // Change control variable value
      this.editContact = !this.editContact
    },

    enableEditing () {
      // Change control variable value
      this.clientDetails.canBeEdited = !this.clientDetails.canBeEdited
      // Save backup data
      this.clientDetails.backup = this.clientDetails.data
    },

    cancelEditing () {
      // Change control variable value
      this.clientDetails.canBeEdited = !this.clientDetails.canBeEdited
      // Restore backup data
      this.clientDetails.data = this.clientDetails.backup
      // Clear backup data
      this.clientDetails.backup = {}

      this.getClient(this.$route.params.clientId)
    },

    updateClient () {
      // Merge data from client and merchant
      this.loading = true
      console.log(this.$refs.clientDetail.validate())
      if (!this.$refs.clientDetail.validate()) {
        return
      }
      // switch (this.merchantDetails.data.status) {
      //   case '0':
      //     console.log('0')
      //     this.clientDetails.data.status = 0
      //     break
      //   case '1':
      //     this.clientDetails.data.status = 1
      //     break
      //   case '2':
      //     this.clientDetails.data.status = 2
      //     break
      //   default:
      //     this.clientDetails.data.status = 1
      // }

      const data = {
        client: this.clientDetails.data,
        merchant: this.merchantDetails.data
      }

      // Aggiorna client con client_id
      apiService
        .updateClient(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Client updated'
          })
          // Close edit menu
          this.clientDetails.canBeEdited = !this.clientDetails.canBeEdited
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot update client.`
          })
          // Close edit menu
          this.clientDetails.canBeEdited = !this.clientDetails.canBeEdited
        })
    },

    addContact (data) {
      apiService
        .createContact('clients', this.$route.params.clientId, data)
        .then(response => {
          this.getClient(this.$route.params.clientId)
        }
        )
        .catch(error => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot create contact.`
          })
        })
    },

    updateContact (contact) {
      console.log('Update contact')
      // Aggiorna client con client_id
      apiService
        .updateContact(contact)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Client updated succesfully.`
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot update client.`
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
    },

    /* #############################
    #           Leads              #
    ############################## */

    getLeads (clientId) {
      const { sortBy, sortDesc, page, itemsPerPage } = this.leadsTable.options
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.client_id = clientId

      apiService
        .fetchData('leads', filter)
        .then((response) => {
          if (response === null) {
            response = []
          }
          this.leadsTable.data = response
          // this.leadsTable.total = response.total || 0
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error loading leads'
          })
        })
    },

    getCampaigns () {
      apiService
        .getCampaigns({ client: this.$route.params.clientId * 1 })
        .then((response) => {
          console.log('Campaigns', response)
          this.campaignsTable.data = response
          this.campaignsTable.total = response.length
          this.dataLoaded = !this.dataLoaded
        })
        .catch((error) => console.log(error))
    },

    getAvailableCampaigns (clientId) {
      apiService
        .getClientAvailableCampaigns(clientId)
        .then((response) => {
          console.log('Campaigns', response)
          this.availableCampaignsList = response
        })
        .catch((error) => console.log(error))
    },

    addCampaign () {
      let campList = this.campaignsList
      let assocCampaigns = this.campaignsTable.data
      console.log(assocCampaigns)

      Object.values(campList).forEach(function (o, i) {
        if (JSON.stringify(assocCampaigns) === JSON.stringify(o)) {
          delete campList[i]
        }
      })

      this.dialog = true
    },

    associateCampaign (campaignId) {
      const data = {
        client_id: this.$route.params.clientId * 1,
        campaign_id: campaignId
      }

      apiService
        .associateClientCampaign(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Campaign associated succesfully`
          })

          this.getCampaigns(this.$route.params.clientId)
          this.getAvailableCampaigns(this.$route.params.clientId)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot update client.`
          })
        })
    },

    /**
     * dissociate a campaign from client
     */
    disassociateCampaign (campaignId) {
      const data = {
        client_id: this.$route.params.clientId,
        campaign_id: campaignId
      }
      apiService
        .disassociateClientCampaign(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Campaign removed succesfully.`
          })

          this.getCampaigns(this.$route.params.clientId)
          this.getAvailableCampaigns(this.$route.params.clientId)
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Error removing campaign.`
          })
        })
    },

    /**
     * Add merchant to the Client
     */
    // Validate and submit form
    validateForm () {
      return this.$refs.newMerchant.validate()
    },

    validateIban (iban) {
      ibanApiService
        .validateIban(iban)
        .then(response => {
          console.log(response)
        })
    },

    createMerchant () {
      if (this.validateForm()) {
        let newMerchantData = this.newMerchantDetails.data
        newMerchantData.merchant.status = 1
        newMerchantData.contacts.referente.is_tech_rep = true
        newMerchantData.contacts.rappresentante.is_legal_rep = true

        newMerchantData.merchant.client = this.$route.params.clientId * 1

        apiService
          .newMerchant(newMerchantData.merchant)
          .then(response => {
            // this.rightDrawer = false

            // Create merchant contacts
            apiService
              .createContact('merchants', response.id, newMerchantData.contacts.referente)
              .then(response => {
                console.log(response)
              })
              .catch(error => {
                console.log(error)
              })

            apiService
              .createContact('merchants', response.id, newMerchantData.contacts.rappresentante)
              .then(response => {
                console.log(response)
              })
              .catch(error => {
                console.log(error)
              })

            // Reload data
            this.getClient(this.$route.params.clientId)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error creating merchant.`
            })
          })
      }
    }
  }
}
</script>
<style scoped>
/deep/ .v-text-field.name-part {
  max-width: 400px;
}
</style>
